import { Link } from 'react-router-dom';
import { Pencil, Languages, Trash2, Eye, Copy, MoreHorizontal } from 'lucide-react';
import { Delete } from '../../../features/DeleteEntity/index.js';
import './ActionBar.css';

export const ActionBar = ({
  editLink,
  viewLink,
  localizationLink,
  onDelete,
  onCopy,
  children,
  className = '',
}) => {
  return (
    <div className={`action-bar ${className}`}>
      {viewLink && (
        <Link to={viewLink} className="action-bar__btn" title="Просмотр">
          <Eye size={18} />
        </Link>
      )}
      {localizationLink && (
        <Link to={localizationLink} className="action-bar__btn" title="Локализации">
          <Languages size={18} />
        </Link>
      )}
      {editLink && (
        <Link to={editLink} className="action-bar__btn action-bar__btn--edit" title="Редактировать">
          <Pencil size={18} />
        </Link>
      )}
      {onCopy && (
        <button
          type="button"
          className="action-bar__btn"
          onClick={onCopy}
          title="Копировать"
        >
          <Copy size={18} />
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          className="action-bar__btn action-bar__btn--delete"
          title="Удалить"
        >
          <Delete onConfirm={onDelete} />
        </button>
      )}
      {children}
    </div>
  );
};

export const ActionButton = ({ icon: Icon, onClick, to, title, variant = 'default', children }) => {
  const className = `action-bar__btn action-bar__btn--${variant}`;
  
  if (to) {
    return (
      <Link to={to} className={className} title={title}>
        {Icon && <Icon size={18} />}
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick} title={title}>
      {Icon && <Icon size={18} />}
      {children}
    </button>
  );
};

export default ActionBar;
